import React from 'react';
import { makeStyles } from 'utils/makeStylesAdapter';
import { Typography, Box, Paper } from '@mui/material';
import { formatDateAndHoursToBrazilian } from 'utils/date-time.utils';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1),
    height: '100%',
    [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap',
    },
  },
  textsimple: {
    wordWrap: 'break-word',
  },
  divDate: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  situationChange: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
}));

const AssociationTimeline = props => {
  const { historyItem, isCreation = false } = props;

  const classes = useStyles();

  const getSituationChangeText = () => {
    if (historyItem.observation) {
      return `Observação adicionada na situação "${historyItem.toSituation}": ${historyItem.observation}.`;
    } else if (isCreation || !historyItem.fromSituation) {
      return `Instituição criada.`;
    } else if (historyItem.fromSituation && historyItem.toSituation) {
      return `Situação mudou de "${historyItem.fromSituation}" para "${historyItem.toSituation}."`;
    }

    return 'Mudança de situação';
  };

  return (
    <Paper elevation={2} className={classes.root}>
      <Box display="flex" flexDirection="row" width="100%" alignItems="flex-start">
        <Box flex={1}>
          <Box className={classes.textsimple} style={{ display: 'flex' }}>
            <Typography variant="h6" className={classes.situationChange}>
              {getSituationChangeText()}
            </Typography>
          </Box>
        </Box>
        <Box className={classes.divDate} ml={3}>
          <Typography variant="h6" className={classes.textsimple}>
            {formatDateAndHoursToBrazilian(historyItem.createdAt)}
            {historyItem.createdByUser?.name
              ? ` - Realizado por: ${historyItem.createdByUser.name}`
              : ''}
          </Typography>
        </Box>
      </Box>

      {historyItem.justification && (
        <Box mt={2} width="100%">
          <Typography variant="body1" className={classes.textsimple}>
            <strong>Justificativa:</strong> {historyItem.justification}
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default AssociationTimeline;
